module.exports =
  brightstore:
    order: '/integrations/brightstore/order'
  walmart:
    addToCart: '/integrations/walmart/addToCart'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/integrations.coffee